import { format, isBefore, isToday, startOfToday } from 'date-fns'
import { DropdownItem, Icon } from 'semantic-ui-react'
import * as React from 'react'

import { classNames } from '../../utils'
import UserName from '../remoteValues/userName'
import { Task } from '../../types'

interface Props {
  onCompleteTaskClick(task: Task): void
  onUpdateTaskClick(task: Task): void
  task: Task
}

export default function CardMenuItemTask(props: Props) {
  const { task, onUpdateTaskClick, onCompleteTaskClick } = props

  const isDueToday = isToday(task.dueDate)
  // const isOverdue = differenceInCalendarDays(task.dueDate, Date.now()) < 0
  const isOverdue = isBefore(task.dueDate, startOfToday())

  return (
    <DropdownItem
      className={classNames(
        '!flex items-baseline gap-3 !whitespace-normal px-4 py-2',
        task.isDone ? 'cursor-auto' : 'cursor-pointer hover:bg-slate-50',
      )}
      onClick={() => onUpdateTaskClick(task)}
    >
      <div>
        {task.isDone ? (
          <Icon
            className="!mr-0 [&.icon.icon.icon]:!bg-primary [&.icon.icon.icon]:opacity-60"
            name="check"
            circular
            inverted
            size="small"
          />
        ) : (
          <Icon
            className="!mr-0 [&.icon]:![box-shadow:0_0_0_.1em_rgba(0,0,0,0.4)_inset] [&::before]:opacity-0 [&::before]:hover:opacity-20"
            name="check"
            circular
            size="small"
            link
            onClick={(e: MouseEvent) => {
              e.stopPropagation()
              onCompleteTaskClick(task)
            }}
          />
        )}
      </div>

      <div className="grow">
        <div
          className={classNames(
            task.isDone && 'text-slate-500 line-through',
            'text-lg leading-snug',
          )}
        >
          {task.subject}
        </div>

        {task.details && (
          <div
            className="mt-1 line-clamp-2 text-sm text-slate-600"
            dangerouslySetInnerHTML={{ __html: task.details || '' }}
          />
        )}

        {isOverdue ? (
          <div className="mt-1.5 text-sm text-slate-500">
            <span className="text-red-600">
              Overdue ({format(task.dueDate, 'P')})
            </span>{' '}
            -{' '}
            <span className="text-slate-600">
              <UserName id={task.assignedToId} short />
            </span>
          </div>
        ) : isDueToday ? (
          <div className="mt-1.5 text-sm text-primary">
            Due today! -{' '}
            <span className="text-slate-600">
              <UserName id={task.assignedToId} short />
            </span>
          </div>
        ) : (
          <div className="mt-1.5 text-sm text-slate-500">
            Due on {format(task.dueDate, 'P')} -{' '}
            <span className="text-slate-600">
              <UserName id={task.assignedToId} short />
            </span>
          </div>
        )}
      </div>
    </DropdownItem>
  )
}
